/**
 * The fleet console's range vocabulary — the CLIENT-SAFE half of
 * `optimization/db.ts` (RO-3-02b).
 *
 * Why this file exists is the same reason `workflow-detail-view.ts` exists, and
 * that file's header states it: `optimization/db.ts` reaches `getDb` and
 * `optimization/config.ts` → `import "server-only"`, so a client component that
 * value-imports ANYTHING from it — even a plain array of labels — drags
 * `server-only` into the browser graph. That is not a warning; it is a
 * whole-app compile error that 500s every route in dev (#44046).
 *
 * `/agents/workflows` needs `WORKFLOW_RANGES` as a VALUE to render its range
 * filter, so the vocabulary moves here and `db.ts` re-exports it — every
 * existing server call site is unchanged, and there is still exactly one
 * definition.
 *
 * The rail: nothing in this module may import a module that reaches the DB.
 */

export type WorkflowRange = "all" | "30d" | "7d" | "24h";

export const WORKFLOW_RANGES: { value: WorkflowRange; label: string }[] = [
  { value: "all", label: "All time" },
  { value: "30d", label: "30 days" },
  { value: "7d", label: "7 days" },
  { value: "24h", label: "24h" },
];

export const WORKFLOW_RANGE_DAYS: Record<WorkflowRange, number | null> = {
  all: null,
  "30d": 30,
  "7d": 7,
  "24h": 1,
};

export function asWorkflowRange(v: string | undefined): WorkflowRange {
  return v === "all" || v === "30d" || v === "7d" || v === "24h" ? v : "all";
}

/** Human label for the active window, used in column/stat headers. */
export function workflowRangeLabel(r: WorkflowRange): string {
  return r === "all" ? "all time" : r === "24h" ? "24h" : r;
}
